const durationList = (min, max) => Object.freeze(
  Array.from({ length: max - min + 1 }, (_, index) => min + index),
);

export const SEEDANCE_REFERENCE_ENDPOINT = Object.freeze({
  modelId: 'bytedance/seedance-2.5/us/reference-to-video',
  textToVideoModelId: 'bytedance/seedance-2.5/us/text-to-video',
  imageToVideoModelId: 'bytedance/seedance-2.5/us/image-to-video',
  limits: Object.freeze({ total: 50, image: 30, video: 10, audio: 10 }),
  duration: Object.freeze({ min: 4, max: 30 }),
  durations: durationList(4, 30),
  resolutions: Object.freeze(['480p', '720p']),
});

export const SEEDANCE_DRAFT_ENDPOINT = Object.freeze({
  ...SEEDANCE_REFERENCE_ENDPOINT,
  completionModelId: 'bytedance/seedance-2.5/draft/complete',
  resolutions: Object.freeze(['480p']),
  completionResolution: '1080p',
  expiresAfterMs: 7 * 24 * 60 * 60 * 1000,
});

export const SEEDANCE_REFERENCE_VIDEO_CONSTRAINTS = Object.freeze({
  acceptedFormats: Object.freeze(['mp4', 'mov']),
  acceptedMimeTypes: Object.freeze(['video/mp4', 'video/quicktime']),
  resolutionPixels: Object.freeze({
    min: 640 * 480,
    max: 1_000_000,
  }),
  maximumDimension: 1280,
  normalization: Object.freeze({
    strategy: 'transcode',
    outputFormat: 'mp4',
    outputMimeType: 'video/mp4',
    videoCodec: 'h264',
  }),
});

export default SEEDANCE_REFERENCE_VIDEO_CONSTRAINTS;
